import { IImageLoadHandlerParams } from '@gem/components';

import Tasks from 'APP/Tasks';
import { ImageCropperPopup } from 'APP/main/PopupManager/Popups/ImageCropperPopup/ImageCropperPopup';

interface ISpaceCollectionFormPresenter {
  onImageLoad(params: IImageLoadHandlerParams): void;
}

export const useSpaceCollectionFormPresenter = (): ISpaceCollectionFormPresenter => {
  const presenter = {
    onImageLoad(params: IImageLoadHandlerParams): void {
      Tasks.app.openPopup(ImageCropperPopup, { params });
    },
  };

  return presenter;
};
